import { i18n } from "@/i18n";

class DateFormatter {
  format(date, type, locale = null) {
    if (!this.canFormat(date)) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("[dateFormatter] valeur non formatable :", date);
      }

      return "";
    }

    locale = locale ? locale : i18n.global.locale;
    const object = new Date(date);
    return i18n.global.d(object, type, locale);
  }

  /**
   * Détermine si la valeur peut être convertie en une date valide.
   * Plus permissif que isDate() : accepte les timestamps numériques et les
   * objets Date, qui sont formatables même s'ils ne "ressemblent" pas à une date.
   */
  canFormat(value) {
    if (value === null || value === undefined || value === "" || typeof value === "boolean") {
      return false;
    }

    return !isNaN(new Date(value).getTime());
  }

  isDate(value) {
    if (!value || typeof value === "boolean" || typeof value === "number") {
      return false;
    }

    if (typeof value === "string" && /^\d+$/.test(value.trim())) {
      return false;
    }

    const date = new Date(value);

    return !isNaN(date.getTime());
  }
}

export const dateFormatter = new DateFormatter();
